import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20dreamy%20anime%20style%20illustration%20with%20floating%20colorful%20manga%20panels%20in%20a%20soft%20coral%20and%20pink%20gradient%20space%2C%20abstract%20comic%20sound%20effects%20and%20speech%20bubbles%2C%20warm%20bokeh%20lights%2C%20ethereal%20atmosphere%2C%20digital%20art%20with%20clean%20composition%2C%20no%20text%2C%20vibrant%20and%20inviting%20color%20palette%20of%20coral%20orange%20and%20soft%20pink&width=1920&height=1080&seq=hero-bika-bg&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 leading-tight">
          哔咔漫画官方指南
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-3 max-w-2xl mx-auto leading-relaxed">
          哔咔下载与使用全攻略 —— 深受二次元爱好者喜爱的漫画阅读平台
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
          海量正版漫画资源，详细下载教程、注册流程、功能特色及常见问题解答，帮助新用户快速上手哔咔，畅享漫画阅读乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/xiazai-jiaocheng"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-cloud-2-line"></i>
            <span>查看下载教程</span>
          </Link>
          <Link
            to="/category/zhuce-zhinan"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-user-add-line"></i>
            <span>新用户注册指南</span>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;